import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueResource from "vue-resource";
import VueJsonp from 'vue-jsonp';
import helpers from './components/helper/global';


Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueJsonp);


Vue.use({
  install() {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
